import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { HelpersEditorModule } from '@core/components/helpers/editor/editor.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillRichTextV1FieldComponent } from './fill-rich-text-v1/fill-rich-text-v1.component';
import { ViewRichTextV1FieldComponent } from './view-rich-text-v1/view-rich-text-v1.component';
import { SettingsRichTextV1FieldComponent } from './settings-rich-text-v1/settings-rich-text-v1.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        HelpersEditorModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillRichTextV1FieldComponent,
        ViewRichTextV1FieldComponent,
        SettingsRichTextV1FieldComponent
    ],
    exports: [
        FillRichTextV1FieldComponent,
        ViewRichTextV1FieldComponent,
        SettingsRichTextV1FieldComponent
    ],

})
export class CoreCustomFormsFieldRichTextV1FieldsModule { }
